
export const blackAccent = '#0b0e0f';
export const offWhite = '#FFFDFA';
export const fontColor = '#000000';
export const defaultGradientStart = '#9c41ff';
export const defaultGradientEnd = '#ffa600';
export const secondaryGradientStart = '#00ffa0';
export const secondaryGradientEnd = '#3385ff'
export const purpleGreenGradientStart = '#9c41ff';
export const purpleGreenGradientEnd = '#00ff64';
export const defaultGradient = `linear-gradient(90deg,${defaultGradientStart} 0%,${defaultGradientEnd} 100%)`;
export const secondaryGradient = `linear-gradient(90deg,${secondaryGradientStart} 0%,${secondaryGradientEnd} 100%)`;
export const purpleGreenGradient = `linear-gradient(90deg,${purpleGreenGradientStart} 0%,${purpleGreenGradientEnd} 100%)`;
export const defaultGradientVerticle = `linear-gradient(180deg,${defaultGradientEnd} 0%,${defaultGradientStart} 100%)`;

export const navBarDarkTheme = '#151c1e';
export const navBarLightTheme = '#fffbf2';

export const greenAccent = '#32de84';
export const blueAccent = '#00E5FF';
export const blueGreenGradient =`linear-gradient(90deg,${blueAccent} 0%,${greenAccent} 100%)`
export const goldAccent = '#ffa600';



